<bn-loading-overlay></bn-loading-overlay>

<h5>Atualização de Informações de Risco</h5>
<div class="container">
  <form class="mt-3 mx-auto" [formGroup]="atualizacaoForm" *ngIf="atualizacaoForm" (keyup.enter)="buscar()">
    <div class="mb-3 row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>
      <div class="col-auto">
        <button class="col-auto btn btn-primary no-margin" type="button"
        [routerLink]="['/atualizacao-info-risco/cadastro']" placement="bottom"
        ngbTooltip="Tela para cadastrar atualização de informações de risco."
        [disabled]="!podeEnviar"><i class="fa fa-file-signature">
        </i> Cadastrar via tela</button>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary no-margin" type="button" (click)="downloadOperacoesQuePrecisamSerInformadas()"
          placement="bottom" ngbTooltip="Tela para download de arquivo com as operações que precisam ser informadas."
          [disabled]="!podeListarOperacoes || (!atualizacaoForm.get('cnpjAgenteFinanceiro').value && !podeEscolherAgente)"><i class="fa fa-download">
          </i> Operações que precisam ser informadas</button>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
      </div>
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar(false, true)" (click)="buscar(false, true)"
          autofocus>Pesquisar</button>
      </div>
    </div>

    <div class="mb-3 row">
      <div class="col-md-6">
        <label  class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
        <select id="agenteFinanceiro" class="form-select" name="agenteFinanceiro" [compareWith]="compararPorId"
          formControlName="cnpjAgenteFinanceiro">
          <option [ngValue]=null>Todos</option>
          <ng-container *ngFor="let item of agentesFinanceiros">
            <option [ngValue]="item.cnpj">{{ item.nome }}</option>
          </ng-container>
        </select>
      </div>
      <div class="col-md-3">
        <label  class="form-label" for="dataEnvioInicio">Data de envio inicial:</label>
        <bn-datepicker name="dataEnvioInicio" idInput="dataEnvioInicio" formControlName="dataEnvioInicial">
        </bn-datepicker>
      </div>
      <div class="col-md-3">
        <label  class="form-label" for="dataEnvioFim">Data de envio final:</label>
        <bn-datepicker name="dataEnvioFim" idInput="dataEnvioFim" formControlName="dataEnvioFinal">
        </bn-datepicker>
      </div>
    </div>

    <div class="mb-3 row">
      <div class="bn-form-group col-md-3">
        <label  class="form-label" for="statusProtocolo">Status Protocolo: </label>
        <select id="statusProtocolo" class="form-select" formControlName="statusProtocolo">
          <option [selected]="true" [ngValue]="null">Todos</option>
          <option *ngFor="let status of valoresStatusProtocolo" [ngValue]="status.codigo">{{ status.label }}</option>
        </select>
      </div>
      <div class="col-md-3">
        <label  class="form-label" for="sistema">Sistema: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
            ngbTooltip="Sistema do contrato, constante dos Boletos de Cobrança enviados pelo BNDES, ou Crédito Livre."></i>
        </label>
        <select id="sistema" class="form-select" name="sistema" [compareWith]="compararPorId" formControlName="sistema">
          <option value=''>Todos</option>
          <option value='CL'>Crédito Livre</option>
          <option value='15'>15 - Contratos FINAME</option>
          <option value='89'>89 - Contratos BNDES</option>
        </select>
      </div>
      <div class="col-md-3">
        <label  class="form-label">Id. externo operação: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
            ngbTooltip="Identificador da operação informado pelo Agente Financeiro em operações Crédito Livre."></i>
        </label>
        <input type="text" class="form-control" name="idExternoOperacao" formControlName="idExternoOperacao" ngDefaultControl>
      </div>
 
      <div class="col-md-3">
        <label  class="form-label">Contrato: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
            ngbTooltip="Número do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."></i>
        </label>
        <input type="text" class="form-control" name="contrato" formControlName="contrato" ngDefaultControl>
      </div>
    </div>
  </form>

</div>

<app-atualizacao-info-risco-listagem *ngIf="pesquisado" [hidden]="esconderPesquisa" [agentesFinanceiros]="agentesFinanceiros"
  [atualizacoesInfoRisco]="atualizacoesInfoRisco" [atributosPaginacao]="atributosPaginacaoComponenteListagem"
  (aoMudarPagina)="mudancaPagina($event)" [ehAgenteFinanceiro]="ehAgenteFinanceiro">
</app-atualizacao-info-risco-listagem>